import { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { screenedValuesOrganization } from "../../tools/constants";
import { OrgManager } from "../../types/organization";
import { Loader } from "../../components/Loader/Loader";
import useIsMobile from "../../hooks/Helper/useIsMobile";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { getOrganizationById } from "../../redux/thunks/organizationThunks";
import { useGlobalContext } from "../../hooks/Helper/GlobalContext";
import { NotificationBanner } from "../../components/NotificationBanner";

export const OrganizationInformation = ({
  headerMarginTop,
}: {
  headerMarginTop: number;
}) => {
  const {photoBannerVisible,PhotoBannerMessage }=useGlobalContext();
  const { t } = useTranslation();
  const { organizationId } = useParams();
  const isMobile = useIsMobile();


  const dispatch = useDispatch<AppDispatch>();

  const { organization, loading, error } = useSelector((state: RootState) => state.organization);

  useEffect(() => {
    if (organizationId && !organization) {
      dispatch(getOrganizationById(organizationId));
    }
  }, [organization]);




  const [submitCount, setSubmitCount] = useState(0);
  const [isExpanded, setIsExpanded] = useState(true);

  const isFormCompleted = useMemo(() => {
    return screenedValuesOrganization[0].every(field => {
      const val = organization && organization[field as keyof typeof organization];
      return val !== "" && val !== null && val !== undefined;
    });
  }, [organization]);



  return (
    <>
      <div id="main-content" style={{ marginTop: headerMarginTop }}>
        <div className="cco_content_area cco_content_area_0">
          <article className="react-container">
               <NotificationBanner
                background="red"
                showBanner={photoBannerVisible}
                message={PhotoBannerMessage}
                color="white"
                type="photo"
                isMobile={isMobile}
            />
            <div className="cco_section cco_section_0">
              <div className="cco_row cco_row_8">
                <div className="cco_col">
                  <div className="cco_text cco_text_11">
                    <div className="cco_text_inner">
                      <strong>
                        <Link to={`/edit/${organizationId}`}> {t("MyCCOPro.OrganizationDetails.breadcrumb")} </Link>
                      </strong>{" "}
                      {" > "}   {t("MyCCOPro.OrganizationDetails.information")}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={
                  isMobile
                    ? undefined
                    : {
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: "20px",
                    }}
              >
                <div
                  style={isMobile
                    ? undefined
                    : { flex: 1 }}
                >
                  <div
                    className={classNames("cco_collapse", {
                      active: isExpanded,
                    })}
                  >
                    <div className="cco_collapse_header">
                      <div className="cco_text cco_text_3">
                        <div className="cco_text_inner">
                          <h3>1.  {t("MyCCOPro.OrganizationDetails.information")}</h3>
                          <div
                            className={classNames({
                              success: isFormCompleted,
                              error: !isFormCompleted,
                            })}
                          >
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="cco_collapse_toggle"
                        onClick={() => setIsExpanded(prev => !prev)}
                      >
                        <span className="cco_collapse_toggle_text">{t("NewLocation.LocationInformation.View")}</span>
                      </button>
                    </div>

                    {loading ? (<Loader />) : (<div className="cco_collapse_body">
                      <div className="cco_collapse_body_inner">
                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.orgName")}</div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.Name ?? "Not completed"}</strong>
                          </div>
                        </div>
                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.legalName")}</div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.LegalName || "Not completed"}</strong>
                          </div>
                        </div>
                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.website")}</div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.WebsiteUrl || "Not completed"}</strong>
                          </div>
                        </div>
                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.type")}</div>
                          <div className="cco_blurb_value">
                            <strong>     {organization?.OrgType
                              ? organization?.OrgType?.Name || "Not completed"
                              : "waiting"}</strong>
                          </div>
                        </div>
                        {organization?.OrgType?.Name === 'Other' && <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.otherType")}</div>
                          <div className="cco_blurb_value">
                            <strong>   {organization?.OtherType || "Not completed"}</strong>
                          </div>
                        </div>}
                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.street1")} </div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.Address1 || "Not completed"}</strong>
                          </div>
                        </div>

                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.street2")} </div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.Address2 || "Not completed"}</strong>
                          </div>
                        </div>

                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.city")}</div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.City || "Not completed"}</strong>
                          </div>
                        </div>

                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.zip")}</div>
                          <div className="cco_blurb_value">
                            <strong>{organization?.ZipCode || "Not completed"}</strong>
                          </div>
                        </div>

                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.state")}</div>
                          <div className="cco_blurb_value">
                            <strong>
                              {(!loading && organization?.State)
                                ? organization?.State?.Name || "Not completed"
                                : "waiting"}
                            </strong>
                          </div>
                        </div>

                        <div className="cco_blurb cco_blurb_1">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationDetails.fields.country")} </div>
                          <div className="cco_blurb_value">
                            <strong>
                              {!loading
                                ? organization?.Country?.Name || "Not completed"
                                : "waiting"}
                            </strong>
                          </div>
                        </div>


                        <div className="cco_btn cco_btn_2">
                          <a href={`/UpdateOrganization/${organization?.OrganizationId}`}>{t("MyCCOPro.OrganizationDetails.edit")}</a>
                        </div>

                      </div>
                    </div>)}
                  </div></div>
                <div
                  style={isMobile
                    ? undefined
                    : { flex: 1 }}
                >
                  <div
                    className={classNames('cco_collapse', {
                      active: isExpanded,
                    })}
                  >
                    <div className="cco_collapse_header">
                      <div className="cco_text cco_text_3">
                        <div className="cco_text_inner">
                          <h3>  {t("MyCCOPro.OrganizationDetails.section2")}</h3>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="cco_collapse_toggle"
                        onClick={() => setIsExpanded(prevState => !prevState)}
                      >
                        <span className="cco_collapse_toggle_text">View</span>
                      </button>
                    </div>

                    {loading ? (<Loader />) : (<div className="cco_collapse_body">
                      <div className="cco_collapse_body_inner">
                        {organization && organization.OrgManagers.map((manager: OrgManager) => (
                          <div key={manager.Id} className="cco_fieldset cco_fieldset_0">
                            <div className="cco_fieldset_item cco_fieldset_item_large">
                              {manager.ManagerName}
                            </div>

                            <div className="cco_fieldset_item">
                              <div className="cco_blurb cco_blurb_5">
                                {manager.IsPrimary ? t("MyCCOPro.OrganizationDetails.fields.primary") : ''}
                              </div>
                            </div>
                          </div>
                        ))}

                        <div className="cco_btn cco_btn_2">
                          <a href={`/org/${organization?.OrganizationId}/add-cm`}>{t("MyCCOPro.OrganizationDetails.edit")}</a>

                        </div>
                      </div>
                    </div>)}

                  </div></div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={() => {
                    window.location.href = `/edit/${organizationId}`;
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#c67b05',
                    padding: '10px 0',
                    fontSize: '16px',
                    cursor: 'pointer',
                    textAlign: 'right',
                  }}
                >
                  ← {t("MyCCOPro.OrganizationDetails.AddManagers.back")}
                </button>
              </div>

            </div>

          </article>

        </div>
      </div>

    </>
  );
}
